import styled from "styled-components";

export const FavouriteContainerStyled = styled.div`
  padding: 20px 18px 104px 18px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .favourite_container {
    .header_sec {
      padding: 0 16px;
      display: flex;
    }
    .title_status {
      margin-bottom: 27px;
      padding: 0 18px;
      border-radius: 12px;
      width: fit-content;
      height: 33px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: ${({ theme }) => theme.COLORS.PURPLE_1};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S19};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .fav_item_wrap {
      margin-bottom: 15px;
    }
    .fav_row {
      display: flex;
      flex-wrap: wrap;
      column-gap: 18px;
      .activities_item {
        margin-bottom: 26px;
        flex-basis: calc(50% - 9px);
        overflow: hidden;
        &:last-child {
          margin-bottom: 0px;
        }
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 40px 18px 104px 18px;
    .breadcrumb_layout {
      display: none;
    }
    .favourite_container {
      .fav_row {
        .activities_item {
          margin-bottom: 18px;
          flex-basis: 100%;
        }
      }
    }
  }
`;
